import React from "react";
import { useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
import { Table, Avatar, Tag, Button } from "antd";
import { EyeOutlined } from "@ant-design/icons";

const ApplicationsTable = ({ data, hideExtraColumns = false }) => {
  const navigate = useNavigate();

  const columns = [
    {
      title: "Tenant",
      dataIndex: "applicantName",
      key: "tenant",
      render: (_, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Avatar src={record.avatar} />
          <span>{record.applicantName}</span>
        </div>
      ),
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
      render: (date) => (date ? new Date(date).toLocaleDateString() : "-"),
    },
    {
      title: "Score",
      dataIndex: "score",
      key: "score",
      render: (score) => (score !== undefined ? `${score}%` : "-"),
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (status) => {
        let color = "orange";
        switch (status?.toLowerCase()) {
          case "new":
            color = "purple";
            break;
          case "rejected":
            color = "red";
            break;
          case "lease sent":
            color = "green";
            break;
          case "lease signed":
            color = "blue";
            break;
          case "tenant":
            color = "cyan";
            break;
          default:
            color = "orange";
        }
        return <Tag color={color}>{status}</Tag>;
      },
    },
  ];

  if (!hideExtraColumns) {
    columns.splice(2, 0, {
      title: "Property",
      dataIndex: "property",
      key: "property",
    });
    columns.splice(3, 0, {
      title: "Rent",
      dataIndex: "amount",
      key: "rent",
    });
    columns.push({
      title: "Payment Info",
      key: "payment",
      render: (_, record) =>
        record.method && record.amount ? (
          <span>
            {record.method} - {record.amount}
          </span>
        ) : (
          "-"
        ),
    });
    columns.push({
      title: "Action",
      key: "action",
      render: (_, record) => (
        <Button
          type="link"
          icon={<EyeOutlined />}
          onClick={() => navigate(`/landlord/applicants/${record.id}`)}
        />
      ),
    });
  }

  return <Table columns={columns} dataSource={data} rowKey="id" />;
};

ApplicationsTable.propTypes = {
  data: PropTypes.array.isRequired,
  hideExtraColumns: PropTypes.bool,
  loading: PropTypes.bool,
};

export default ApplicationsTable;
